import { render, staticRenderFns } from "./PhoneNavigation.vue?vue&type=template&id=0933e430&scoped=true&"
import script from "./PhoneNavigation.vue?vue&type=script&lang=js&"
export * from "./PhoneNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNavigation.vue?vue&type=style&index=0&id=0933e430&scoped=true&lang=scss&"
import style1 from "./PhoneNavigation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0933e430",
  null
  
)

export default component.exports